"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESortBy = exports.ESaleType = exports.BlockchainE = exports.ResponseMetaStatusE = void 0;
var ResponseMetaStatusE;
(function (ResponseMetaStatusE) {
    ResponseMetaStatusE["UNSPECIFIED"] = "Unspecified";
    ResponseMetaStatusE["OK"] = "OK";
    ResponseMetaStatusE["UNAUTHORIZED"] = "Unauthorized";
    ResponseMetaStatusE["FORBIDDEN"] = "Forbidden";
    ResponseMetaStatusE["FAILED_PRECONDITION"] = "FailedPrecondition";
    ResponseMetaStatusE["SYSTEM_ERROR"] = "SystemError";
    ResponseMetaStatusE["NOT_FOUND"] = "NotFound";
})(ResponseMetaStatusE = exports.ResponseMetaStatusE || (exports.ResponseMetaStatusE = {}));
var BlockchainE;
(function (BlockchainE) {
    BlockchainE["ETHEREUM"] = "ethereum";
    BlockchainE["CONCORDIUM"] = "concordium";
})(BlockchainE = exports.BlockchainE || (exports.BlockchainE = {}));
var ESaleType;
(function (ESaleType) {
    ESaleType["Unspecified"] = "Unspecified";
    ESaleType["BuyNow"] = "BuyNow";
    ESaleType["TimedAuction"] = "TimedAuction";
    ESaleType["NotOnSale"] = "NotOnSale";
    ESaleType["OpenForOffers"] = "OpenForOffers";
})(ESaleType = exports.ESaleType || (exports.ESaleType = {}));
var ESortBy;
(function (ESortBy) {
    ESortBy["Unspecified"] = "Unspecified";
    ESortBy["Date"] = "Date";
    ESortBy["Price"] = "Price";
    ESortBy["Name"] = "Name";
    ESortBy["Copies"] = "Copies";
})(ESortBy = exports.ESortBy || (exports.ESortBy = {}));
